import React from 'react';
import { Formik } from 'formik';
import {
    TextField,
    withStyles,
    Select,
    MenuItem,
    FormControl,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox,
    InputLabel,
    CircularProgress,
} from '@material-ui/core';
import * as Yup from 'yup';
import FormStep2 from './FormStep2';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    button: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px'
    },
    formControl: {
        width: '100%'
    }
});

const FormStep1Service = props => {

    const {
        classes,
        isDirty,
        edit,
        handleSubmit,
        initialValues,
        translations,
        formSettings
    } = props;

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape(formSettings.Validation)}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validateOnMount={true}
        >
            {formikProps => {
                const { values, touched, errors, dirty, isValid, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                return (
                    <div className={classes.root}>
                        <form onSubmit={handleSubmit}>
                            <>
                                <TextField
                                    name="Name"
                                    value={values.Name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Name && touched.Name)}
                                    placeholder={translations["name"] || "Name"}
                                    label={translations["name"] || "Name"}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <FormControl id="direction_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['please_select_direction'] || "Please select direction"}</InputLabel>
                                    <Select
                                        name="Direction"
                                        label={translations['direction'] || 'Direction'}
                                        margin={"dense"}
                                        value={values.Direction}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"in"}>
                                            {translations['in'] || 'in'}
                                        </MenuItem>
                                        <MenuItem value={"out"}>
                                            {translations['out'] || 'out'}
                                        </MenuItem>
                                        <MenuItem value={"in+out"}>
                                            {`${translations['in'] || 'in'}+${translations['out'] || 'out'}`}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl id="active_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations["active"] || "Active"}</InputLabel>
                                    <Select
                                        name="Active"
                                        value={values.Active}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.Active && touched.Active)}
                                        placeholder={translations["active"] || "Active"}
                                        label={translations["active"] || "Active"}
                                        margin={"dense"}
                                        fullWidth={true}
                                    >
                                        <MenuItem value={true}>
                                            {translations['active'] || 'Active'}
                                        </MenuItem>
                                        <MenuItem value={false}>
                                            {translations['inactive'] || 'Inactive'}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl id="service_type_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['select_service_type'] || "Please select service type"}</InputLabel>
                                    <Select
                                        name="ServiceType"
                                        label={translations['service_type'] || 'Service type'}
                                        margin={"dense"}
                                        value={values.ServiceType === '' ? 'asset_v1' : values.ServiceType}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"asset_v1"}>
                                            asset_v1
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    name="Hostname"
                                    value={values.Hostname}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Hostname && touched.Hostname)}
                                    placeholder={translations["hostname"] || "Hostname"}
                                    label={translations["hostname"] || "Hostname"}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <FormControl id="protocol_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['select_protocol'] || "Please select protocol"}</InputLabel>
                                    <Select
                                        name="Protocol"
                                        label={translations['protocol'] || 'Protocol'}
                                        margin={"dense"}
                                        value={values.Protocol}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"http:"}>
                                            HTTP
                                                </MenuItem>
                                        <MenuItem value={"https:"}>
                                            HTTPS
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl id="auth_type_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['select_authentication_type'] || "Please select authentication type"}</InputLabel>
                                    <Select
                                        name="AuthType"
                                        label={translations['auth_type'] || 'Auth type'}
                                        margin={"dense"}
                                        value={values.AuthType}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"bearer"}>
                                            Bearer
                                        </MenuItem>
                                        <MenuItem value={"basic"}>
                                            Basic
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                {values.AuthType === "basic" &&
                                    <FormStep2 handleSubmit={handleSubmit} 
                                        initialValues={initialValues} 
                                        translations={translations} 
                                        formSettings={formSettings} 
                                        values={values} 
                                        handleChange={handleChange}
                                        handleBlur={handleBlur}
                                        errors={errors}
                                        touched={touched}
                                        isSubmitting={isSubmitting}
                                        isValid={isValid}
                                        dirty={dirty}
                                    />
                                }
                                
                                <TextField
                                    name="Port"
                                    value={values.Port}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type='number'
                                    error={!!(errors.Port && touched.Port)}
                                    placeholder={translations['port'] || 'Port'}
                                    label={translations['port'] || 'Port'}
                                    margin={'dense'}
                                    fullWidth={true}
                                />
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                margin={"dense"}
                                                name={"UseExternalTypicalProblems"}
                                                checked={values.UseExternalTypicalProblems}
                                                onChange={handleChange}
                                                color={'primary'}
                                            />
                                        }
                                        label={translations["use_external_typical_problems"] || "Use external typical problems"}
                                    />
                                </FormGroup>
                            </>
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={!edit ? !isValid || isSubmitting : !((isValid && dirty) || isDirty) || isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                            formSettings.ButtonSubmit.Title
                                        )}
                                </Button>
                            ) : null}
                        </form>
                    </div>
                );
            }}
        </Formik>
    );
};

export default withStyles(styles, { withTheme: true })(FormStep1Service);